











import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ReturnTopButton'
})
export default class ReturnTopButton extends Vue {

  public buttonActive = false
  public scroll = 0
  public buttonColor = '#0055b6'

  mounted() {
    window.addEventListener('scroll', this.scrollWindow)
  }

  scrollWindow() {
    const top = 100
    this.scroll = window.scrollY
    if (top <= this.scroll) {
      this.buttonActive = true
    } else {
      this.buttonActive = false
    }
  }

  returnTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
}
